const { BASE_URL } = require("./client");

const GET_PASSWORDS = BASE_URL + "/api/admin/password/get";
const VALIDATE_PASSWORD = BASE_URL + "/api/admin/password/verify";

export { GET_PASSWORDS, VALIDATE_PASSWORD };
